export enum Unit {
  feet = 'ft',
  inches = 'in',
  meters = 'm',
  centimeters = 'cm',
  millimeters = 'mm',
}

export enum MeasurementSystem {
  metric = 'metric',
  imperial = 'imperial',
}

export type UnitType =
  | 'area'
  | 'net-area'
  | 'gross-area'
  | 'linear'
  | 'rentable-area';

export const UNIT_ABBREVIATIONS_MAP: Record<Unit, string> = {
  [Unit.feet]: 'ft',
  [Unit.inches]: 'in',
  [Unit.meters]: 'm',
  [Unit.centimeters]: 'cm',
  [Unit.millimeters]: 'mm',
};

export const UNIT_NAMES_MAP: Record<Unit, string> = {
  [Unit.feet]: 'feet',
  [Unit.inches]: 'inches',
  [Unit.meters]: 'meters',
  [Unit.centimeters]: 'centimeters',
  [Unit.millimeters]: 'milimeters',
};

export const AREA_UNIT_ABBREVIATIONS_MAP: Record<Unit, string> = {
  [Unit.feet]: 'USF',
  [Unit.inches]: 'SQ IN',
  [Unit.meters]: 'USM',
  [Unit.centimeters]: 'SQ CM',
  [Unit.millimeters]: 'SQ MM',
};
